var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { z } from "zod";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Icon, Stepper, useStepper } from "@opala-ds/react";
import { useIsMobile } from "../../hooks/useIsMobile";
import FormActions from "./FormActions";
import React, { useEffect, useState } from "react";
import RegiterIndividualCategoryAndModalityDataForm, { Schema as RegiterIndividualCategoryAndModalityScheme, } from "./RegiterIndividualCategoryAndModalityDataForm";
import TableModalities from "../TableModalities";
var Schema = z.object({
    modalidades: z
        .array(RegiterIndividualCategoryAndModalityScheme)
        .min(1, "Adicione pelo menos uma modalidade para continuar"),
});
export default function ModalitiesRegisteredForm(_a) {
    var _this = this;
    var _b, _c;
    var onSubmit = _a.onSubmit, _d = _a.defaultValues, defaultValues = _d === void 0 ? {
        modalidades: [],
    } : _d;
    var _e = useState(), viewIndividualModalityForm = _e[0], setViewIndividualModalityForm = _e[1];
    var _f = useForm({
        defaultValues: defaultValues,
        resolver: zodResolver(Schema),
    }), setValue = _f.setValue, watch = _f.watch, getValues = _f.getValues, handleSubmit = _f.handleSubmit, errors = _f.formState.errors;
    var modalidadesWatch = watch("modalidades");
    useEffect(function () {
        if (modalidadesWatch.length === 0) {
            setViewIndividualModalityForm(true);
        }
    }, [modalidadesWatch]);
    var nextStep = useStepper().nextStep;
    var isMobile = useIsMobile();
    var handleDeleteModalidade = function (id) {
        var currentModalidades = getValues("modalidades");
        var updatedModalidades = currentModalidades.filter(function (_, index) { return index !== id; });
        setValue("modalidades", updatedModalidades);
    };
    return (_jsxs("form", __assign({ className: "w-full flex flex-col space-y-5", onSubmit: handleSubmit(function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, onSubmit(data)];
                    case 1:
                        _a.sent();
                        nextStep();
                        return [2 /*return*/];
                }
            });
        }); }) }, { children: [isMobile && (_jsx("div", __assign({ className: "flex justify-start" }, { children: _jsx(Stepper.Radial, { size: 70, weight: 5 }) }))), _jsx(TableModalities, { modalities: modalidadesWatch.map(function (modalidade, index) { return ({
                    id: index,
                    genero: modalidade.genero,
                    categoria: modalidade.categoria,
                    modalidades_individuais: modalidade.modalidades_individuais,
                }); }), handleDelete: function (index) { return handleDeleteModalidade(index); }, handleAddModality: function () {
                    setViewIndividualModalityForm(true);
                } }), viewIndividualModalityForm && (_jsxs("div", { children: [_jsxs("p", __assign({ className: "text-sm font-semibold text-[#022A59] mb-5 mt-12" }, { children: ["Modalidade #", modalidadesWatch.length + 1] })), _jsx(RegiterIndividualCategoryAndModalityDataForm, { handleCancelAction: function () { return setViewIndividualModalityForm(false); }, onSubmit: function (data) {
                            setValue("modalidades", __spreadArray(__spreadArray([], getValues("modalidades"), true), [
                                {
                                    genero: data.genero,
                                    categoria: data.categoria,
                                    modalidades_individuais: data.modalidades_individuais,
                                },
                            ], false));
                        } }), _jsx("hr", { className: "w-full border border-black" })] })), ((_b = errors.modalidades) === null || _b === void 0 ? void 0 : _b.message) && (_jsx("div", __assign({ className: "w-full flex flex-col items-end gap-1 mt-1.5" }, { children: _jsxs("div", __assign({ className: "flex items-center gap-1 mt-1" }, { children: [_jsx(Icon, { name: "CircleX", size: 16, color: "#8C1D0A" }), _jsx("span", __assign({ className: "text-sm text-[#8C1D0A]" }, { children: (_c = errors.modalidades) === null || _c === void 0 ? void 0 : _c.message }))] })) }))), _jsx(FormActions, {})] })));
}
